import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-category-title',
  templateUrl: './category-title.component.html',
  styleUrls: ['./category-title.component.css'],
})
export class CategoryTitleComponent {
  @Input() title: string;
  @Input() subtitle?: string;
  @Input() stepNumber: string;
  @Input() totalSteps: string;
}
